// Define product categories
const bracelets = [
  {
    id: 'direct1',
    name: '14k Classic Diamond Bracelet',
    price: 'Request for price',
    category: 'bracelets',
    description: 'Elegant 14k gold bracelet featuring brilliant-cut diamonds in a classic tennis style design. Perfect for both formal occasions and everyday luxury.',
    inStock: true,
    featured: true,
    discount: 15, // 15% discount
    image: './media/bracelets/1.jpg',
    createdAt: new Date().toISOString()
  }
];

const earrings = [
  {
    id: 'direct2',
    name: 'Stunning Crafted Diamond Earrings',
    price: 'Request for price',
    category: 'earrings',
    description: 'Exquisitely crafted diamond stud earrings with secure screw backs. These versatile earrings feature brilliant-cut diamonds set in premium metal for maximum sparkle.',
    inStock: true,
    featured: true,
    discount: 20, // 20% discount
    image: './media/earrings/1.jpg',
    createdAt: new Date().toISOString()
  }
];

const necklaces = [
  {
    id: 'direct3',
    name: 'Elegant Green Stone Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Sophisticated pendant necklace featuring a stunning emerald center stone surrounded by a halo of diamonds. Set in premium metal with an adjustable chain.',
    inStock: true,
    featured: false,
    discount: 0, // No discount
    image: './media/necklaces/2.jpg',
    createdAt: new Date().toISOString()
  },
  {
    id: 'direct4',
    name: 'Stunning Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Breathtaking diamond necklace with graduated stones creating a cascade effect. Features over 5 carats of premium diamonds set in a secure prong setting.',
    inStock: true,
    featured: true,
    discount: 25, // 25% discount
    image: './media/necklaces/3.jpg',
    createdAt: new Date().toISOString()
  },
  {
    id: 'direct5',
    name: 'Elegant Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Timeless diamond pendant necklace featuring a solitaire diamond in a classic setting. The adjustable chain allows for versatile styling options.',
    inStock: true,
    featured: false,
    discount: 10, // 10% discount
    image: './media/necklaces/4.jpg',
    createdAt: new Date().toISOString()
  },
  {
    id: 'direct8',
    name: 'Stunner Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Statement diamond necklace with a unique geometric design. Multiple diamonds are arranged in a contemporary pattern that catches the light from every angle.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/5.jpg',
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString() // 7 days ago
  }
];

const rings = [
  {
    id: 'direct6',
    name: 'Lumos Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Brilliant solitaire diamond ring with a unique halo design that maximizes light reflection. The cathedral setting elevates the center stone for maximum visibility.',
    inStock: true,
    featured: true,
    discount: 0,
    image: './media/rings/1.jpg',
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString() // 2 days ago
  },
  {
    id: 'direct7',
    name: 'Essential Promise Band',
    price: 'Request for price',
    category: 'rings',
    description: 'Elegant promise ring featuring a row of channel-set diamonds. The comfort-fit band makes this ring perfect for everyday wear while symbolizing your commitment.',
    inStock: true,
    featured: false,
    discount: 15,
    image: 'https://images.unsplash.com/photo-1589674781759-c21c37956a44?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&h=800&q=80',
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString() // 5 days ago
  },
  {
    id: 'direct9',
    name: 'Radiance Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Stunning engagement ring featuring a brilliant-cut center diamond surrounded by a double halo of smaller diamonds. The split-shank band adds additional sparkle.',
    inStock: true,
    featured: true,
    discount: 10,
    image: './media/rings/2.jpg',
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString() // 1 day ago
  },
  {
    id: 'direct10',
    name: 'Classic 14k Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Timeless 14k gold ring with a round brilliant diamond in a classic four-prong setting. The simple, elegant design makes this ring perfect for everyday wear.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/3.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct11',
    name: 'Timeless Glamour Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Vintage-inspired diamond ring featuring a cushion-cut center stone surrounded by a halo of smaller diamonds. The milgrain detailing adds a touch of old-world charm.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/4.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct12',
    name: 'Induring Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Contemporary diamond ring with a unique tension setting that makes the center stone appear to float. The minimalist design highlights the beauty of the diamond.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/7.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct13',
    name: 'Dazzling Heart Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Romantic heart-shaped diamond ring with pavé-set accent diamonds along the band. The perfect expression of love for anniversaries or engagements.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/8.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct14',
    name: 'Blossom Sparkle Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Floral-inspired diamond ring featuring a cluster of diamonds arranged in a flower pattern. The nature-inspired design brings a unique and feminine touch.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/12.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct15',
    name: 'Geometric Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Modern geometric diamond ring with a hexagonal halo surrounding the center stone. The architectural design creates a bold and contemporary statement.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/15.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct16',
    name: 'Bold Brilliance Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Statement cocktail ring featuring a large center diamond surrounded by multiple smaller diamonds. The wide band provides comfort while making a bold fashion statement.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/16.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct17',
    name: 'Blooming Radiance Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Floral-inspired engagement ring with a round brilliant diamond center and petal-shaped diamond accents. The intricate design captures the beauty of a blooming flower.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/17.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct18',
    name: 'Charming 14k Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Delicate 14k gold ring with a dainty row of pavé-set diamonds. The slim profile makes it perfect for stacking or wearing as a subtle everyday piece.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/18.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct19',
    name: 'Majestic Gleem Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Luxurious three-stone diamond ring symbolizing your past, present, and future. The tapered baguette side stones complement the brilliant center diamond.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/19.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct20',
    name: 'Eternal Radiance Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Eternity band featuring a continuous circle of perfectly matched diamonds. Symbolizing never-ending love, this ring is ideal for weddings or significant anniversaries.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/20.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct21',
    name: 'Serenity Diamond Ring',
    price: 'Request for price',
    category: 'rings',
    description: 'Calming wave-inspired diamond ring with a flowing design that wraps around the finger. The organic shape creates a sense of movement and grace.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/rings/21.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct22',
    name: 'Luxearia Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Luxurious diamond collar necklace with graduated stones creating a waterfall effect. The flexible design contours to the neckline for comfortable all-day wear.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/6.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct23',
    name: 'Glamorous Cascade Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Dramatic cascading diamond necklace with multiple tiers of brilliant stones. This statement piece is perfect for red carpet events and special celebrations.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/7.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct24',
    name: '14k Rose Gold Rare Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Unique 14k rose gold necklace with a delicate diamond pendant. The warm hue of the rose gold complements all skin tones and adds a romantic touch.',
    inStock: true,
    featured: true,
    discount: 0,
    image: './media/necklaces/8.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct25',
    name: 'Regal Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Majestic diamond necklace inspired by royal jewelry designs. Features multiple diamond stations connected by delicate chains for a sophisticated look.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/9.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct26',
    name: 'Refined Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Elegant diamond solitaire necklace with a floating design that highlights the center stone. The minimalist style makes it perfect for everyday luxury.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/10.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct27',
    name: 'Classic Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Timeless diamond pendant necklace featuring a round brilliant diamond in a classic four-prong setting. A versatile piece that transitions from day to evening.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/11.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct28',
    name: 'Luminescent Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Radiant diamond necklace with a unique setting that maximizes light reflection. The special cut of the diamonds creates exceptional brilliance and fire.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/12.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct29',
    name: 'Elegant Allure Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Sophisticated diamond necklace with a Y-shaped drop design. The adjustable chain allows for versatile styling, making it suitable for various necklines.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/13.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct30',
    name: 'Lush Broad Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Opulent wide diamond collar necklace with intricate patterns. The substantial design makes a bold statement while remaining comfortable against the skin.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/14.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 'direct31',
    name: 'Refined Diamond Necklace',
    price: 'Request for price',
    category: 'necklaces',
    description: 'Delicate diamond station necklace with evenly spaced stones along a fine chain. The subtle sparkle adds elegance to any outfit without overwhelming.',
    inStock: true,
    featured: false,
    discount: 0,
    image: './media/necklaces/15.jpg',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  }

];

// Direct product data for the entire application
export const DIRECT_PRODUCTS = [
  ...bracelets,
  ...earrings,
  ...necklaces,
  ...rings
].map(product => ({
  ...product,
  // Ensure all products have consistent properties
  id: product.id || `direct${Date.now()}`,
  inStock: product.inStock !== undefined ? product.inStock : true,
  featured: product.featured !== undefined ? product.featured : false,
  discount: product.discount || 0,
  weight: product.weight || '',
  pageLocation: product.pageLocation || []
}));

// Helper functions for product operations
export const getProductById = (id) => {
  return DIRECT_PRODUCTS.find(p => p.id === id) || null;
};

export const getProductsByCategory = (category) => {
  return DIRECT_PRODUCTS.filter(p => 
    p.category.toLowerCase() === category.toLowerCase() && p.inStock
  );
};

export const getFeaturedProducts = (limit = 5) => {
  return DIRECT_PRODUCTS
    .filter(p => p.featured && p.inStock)
    .slice(0, limit);
};

export const getNewArrivals = (limit = 5) => {
  return [...DIRECT_PRODUCTS]
    .filter(p => p.inStock)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, limit);
};

export const getSpecialOffers = (limit = 5) => {
  return DIRECT_PRODUCTS
    .filter(p => p.inStock && (p.discount > 0 || p.featured))
    .slice(0, limit);
};

export const addProduct = (product) => {
  const newProduct = {
    ...product,
    id: `direct_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    createdAt: new Date().toISOString()
  };
  
  DIRECT_PRODUCTS.push(newProduct);
  return newProduct;
};

export const updateProduct = (id, updatedProduct) => {
  const index = DIRECT_PRODUCTS.findIndex(p => p.id === id);
  
  if (index === -1) {
    return null;
  }
  
  DIRECT_PRODUCTS[index] = {
    ...DIRECT_PRODUCTS[index],
    ...updatedProduct,
    id // Ensure ID doesn't change
  };
  
  return DIRECT_PRODUCTS[index];
};

export const deleteProduct = (id) => {
  const index = DIRECT_PRODUCTS.findIndex(p => p.id === id);
  
  if (index === -1) {
    return false;
  }
  
  DIRECT_PRODUCTS.splice(index, 1);
  return true;
};

export const searchProducts = (searchTerm) => {
  if (!searchTerm) {
    return DIRECT_PRODUCTS.filter(p => p.inStock);
  }
  
  const term = searchTerm.toLowerCase();
  return DIRECT_PRODUCTS.filter(p => 
    p.inStock && (
      p.name.toLowerCase().includes(term) ||
      p.category.toLowerCase().includes(term) ||
      (p.description && p.description.toLowerCase().includes(term))
    )
  );
};

export default {
  DIRECT_PRODUCTS,
  getProductById,
  getProductsByCategory,
  getFeaturedProducts,
  getNewArrivals,
  getSpecialOffers,
  addProduct,
  updateProduct,
  deleteProduct,
  searchProducts
}; 